import { Typography } from "@mui/material";
import styled, { DefaultTheme } from "styled-components/macro";
import { DeviceType } from "../../utils/hooks/useDeviceHook";

export const FileUploaderWrapper = styled.div``;

export const FileUploaderTitle = styled.div`
  width: 100%;
  color: #5d5a5a;
  font-size: 14px;
  font-weight: 900;
  text-transform: uppercase;
  line-height: 20px;
  word-wrap: break-word;
  margin-top: 32px;
  margin-bottom: 10px;
`;

export const FileUploaderDropzoneWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  justify-content: center;
  display: flex;

  .dzu-dropzoneActive {
    opacity: 0.7;
  }

  .dzu-inputLabelWithFiles {
    color: ${({ theme }) => theme.redMedium};
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.redMedium};
    border-radius: 3rem;
    width: 100px;
    font-size: 14px !important;
    margin: 10px 10px !important;
    display: ${({ deviceType }) =>
      deviceType === "mobile" ? "none" : undefined};
  }
`;

export const InsuranceFileUploaderDropzoneAntigen = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: 1px dashed ${({ theme }) => theme.neutral400};
  padding: 35px 0px;
  grid-column-gap: 10px;
`;

export const InsuranceFileUploaderMobile = styled.div`
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: ${({ theme }) => theme.greenDark};
`;

export const InsuranceFileUploaderHelpText = styled.div`
  margin-left: 32px;
`;

export const InsuranceFileUploaderGreyText = styled(Typography)<{
  fixedWidth?: boolean;
}>`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.greyMedium};
  text-align: left;
  ${({ fixedWidth }) => fixedWidth && "width: 180px;"};
`;

export const FileUploaderBrowse = styled(Typography)`
  text-align: center;
  color: ${({ theme }) => theme.white};
  background-color: ${({ theme }) => theme.greenDark};
  border: 1px solid ${({ theme }) => theme.white};
  border-radius: 3rem;
  padding: 11px 16px;
  width: 188px;
  font-size: 14px !important;
  margin: auto !important;
  text-transform: uppercase;
  font-weight: bold !important;

  button {
    padding: 4px 16px;
    font-family: light !important;
  }

  :hover {
    opacity: 0.9;
  }
`;

const getUploadBorder = (validUpload: boolean | undefined) => {
  if (validUpload === undefined || validUpload) {
    return "2px dashed green";
  }
  return "2px dashed red";
};

const getPreviewBackground = (
  theme: DefaultTheme,
  validUpload: boolean | undefined,
) => {
  if (validUpload === undefined || validUpload) {
    return theme.greenPastel;
  }
  return theme.redPastel;
};

export const FileUploaderPreview = styled.div<{
  validUpload: boolean | undefined;
}>`
  display: grid;
  grid-template-columns: auto auto;
  border-radius: 6px;
  background-color: ${({ validUpload, theme }) =>
    getPreviewBackground(theme, validUpload)};
  height: 105px;
  min-width: 275px;
  width: 90%;
  padding: 10px 10px;
  border: ${({ validUpload }) => getUploadBorder(validUpload)};
  margin: 8px 0px 0px 0px;

  img {
    width: 80px;
    height: auto;
  }
`;

export const FileUploaderPreviewMobileImage = styled.div`
  img {
    width: 300px;
    height: 200px;
    border: 2px dashed ${({ theme }) => theme.neutral200};
    border-radius: 12px;
  }
`;

export const FileUploaderPreviewTitle = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-self: flex-start;
  align-items: center;
  grid-column-gap: 20px;
`;
export const FileNameUploaded = styled.div`
  width: 100px;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
`;

export const FileUploaderPreviewDelete = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-self: flex-end;
  align-items: center;
  grid-column-gap: 20px;
`;

export const FileUploaderPreviewError = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.redMedium};
`;
